import { sourceSystemTypes, buyFlowTypes } from '../constants/session'

export const selectThemeType = state => {
  return state.session.themeType
}

export const selectSourceSystemType = state => {
  return state.session?.sourceSystem
}

export function selectIsOrionSales(state) {
  return state.session?.sourceSystem === sourceSystemTypes.orionsales
}

export const selectIsAddendumSelected = state => {
  return state.session?.buyflowType === buyFlowTypes.addendum
}